import Changes from './changes.webp';
import Launcher from './launcher.webp';
import Loading from './loading.webp';
import Main from './main.webp';
import Material from './material.webp';
import MRT from './mrt.webp';
import Sky from './sky.webp';
import Terrain from './terrain.webp';
import TMaterial from './tmaterial.webp';

export default {
    Changes,
    Launcher,
    Loading,
    Main,
    Material,
    MRT,
    Sky,
    Terrain,
    TMaterial
}